import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "selection__img-wrapper"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "selection__img-fallback"
}
const _hoisted_4 = { class: "selection__text-wrapper" }
const _hoisted_5 = { class: "selection__title-wrapper" }
const _hoisted_6 = { class: "selection__title" }
const _hoisted_7 = {
  key: 0,
  class: "selection__compatibility"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 3,
  class: "selection__action-item"
}

import IconTooltip from './shared/IconTooltip.vue';
import { computed, onMounted} from 'vue';
import {useStore} from "vuex";

export default /*#__PURE__*/_defineComponent({
  props: {
    id: String,
    displayName: String,
    description: String,
    imageUrl: String,
    route: String,
    isSelected: Boolean,
    isDisabled: Boolean,
    fieldId: String,
    categoryType: String,
    compatibilityMessage: String,
    productDetailPageUrl: String,
    compatibilityModalMessage: String,
	clearSelections: {
		type: Array,
		default: () => []
	}
},
  emits: ['update-route', 'update-selection'],
  setup(__props, { emit }) {

const props = __props

const store = useStore();



const imageUrlWithParam = computed(() => {
	return props.imageUrl.includes("transparentbackground") ? (props.imageUrl.includes("?") ? `${props.imageUrl}&fmt=png-alpha` : `${props.imageUrl}?fmt=png-alpha`) : props.imageUrl;
});

const resetSelections = (event) => {
	event.stopPropagation();
	store.dispatch('removeLock', props);
};

const isLink = computed(() => {
    return !!props.route;
});
const isLinkSelected = computed(() => {
    return !!props.route && props.isSelected;
});

const descriptionOrLink = computed(() => {
    return props.productDetailPageUrl ? `<a href="${props.productDetailPageUrl}" target="_blank">${props.description}</a>` : props.description;
});

function handleClick() {
    if (!!props.route) {
        emit('update-route', props.route);
    } else if (!!props.fieldId) {
        emit('update-selection', { selection: props, fieldId: props.fieldId });
    }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["selection__wrapper", { selection__isSelected: _unref(isLinkSelected) ? false : __props.isSelected, selection__isLink: _unref(isLink), selection__isDisabled: !!__props.isDisabled }]),
    onClick: handleClick
  }, [
    (__props.imageUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "selection__img",
            src: _unref(imageUrlWithParam)
          }, null, 8 /* PROPS */, _hoisted_2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa-thin', 'fa-circle-quarters'],
            class: "selection__img-fallback-icon"
          })
        ])),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", _hoisted_6, _toDisplayString(__props.displayName), 1 /* TEXT */),
        (!!__props.compatibilityMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(IconTooltip, {
                tooltipMessage: __props.compatibilityMessage,
                isHtml: true
              }, null, 8 /* PROPS */, ["tooltipMessage"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      (!!__props.description)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "selection__description",
            innerHTML: _unref(descriptionOrLink)
          }, null, 8 /* PROPS */, _hoisted_8))
        : _createCommentVNode("v-if", true)
    ]),
    (__props.clearSelections?.length)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "selection__reset-lock",
          onClick: resetSelections,
          title: "Remove Lock"
        }, "×"))
      : _createCommentVNode("v-if", true),
    (!!__props.route)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa-thin', 'fa-chevron-right'],
            class: "selection__action-item-icon"
          })
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})